import { categories } from "@/data/questions";
import { Progress } from "@/components/ui/progress";
import { AssessmentDimension } from "@/types/assessment";
import { GraduationCap } from "lucide-react";

interface AssessmentHeaderProps {
  currentQuestionIndex: number;
  totalQuestions: number;
  currentDimension: AssessmentDimension;
}

export const AssessmentHeader = ({ currentQuestionIndex, totalQuestions, currentDimension }: AssessmentHeaderProps) => {
  const progress = ((currentQuestionIndex + 1) / totalQuestions) * 100;
  const currentCategory = categories.find(cat => cat.id === currentDimension);

  return (
    <>
      <div className="text-center mb-8">
        <div className="flex items-center justify-center gap-3 mb-4">
          <GraduationCap className="w-12 h-12 text-secondary animate-bounce" />
          <h1 className="text-3xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
            AI Maturity Assessment and Alignment (AIMAA)
          </h1>
        </div>
        <p className="text-muted-foreground text-lg">
          Evaluate your organization's AI adoption and capabilities
        </p>
      </div>

      {currentCategory && (
        <div className="mb-6 bg-white/50 backdrop-blur-sm rounded-lg p-6 shadow-lg">
          <h2 className="text-2xl font-semibold text-primary mb-2">{currentCategory.title}</h2>
          <p className="text-muted-foreground mb-4">{currentCategory.description}</p>
        </div>
      )}

      <div className="mb-6">
        <Progress value={progress} className="h-3 bg-secondary/20" />
        <p className="text-sm text-muted-foreground mt-2 font-medium">
          Question {currentQuestionIndex + 1} of {totalQuestions}
        </p>
      </div>
    </>
  );
};